import { render, staticRenderFns } from "./CreateVpc.vue?vue&type=template&id=2be55ecc&scoped=true&"
import script from "./CreateVpc.vue?vue&type=script&lang=js&"
export * from "./CreateVpc.vue?vue&type=script&lang=js&"
import style0 from "./CreateVpc.vue?vue&type=style&index=0&id=2be55ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be55ecc",
  null
  
)

export default component.exports